import { CpPlansInterface } from '../../../../interfaces/dto/client-portal/plans/plans-interface';

export class CpPlansModel implements CpPlansInterface {
  productCode: string = "";
  productId: string = "";
  currency: string = "";
  description: string = "";
  name: string = "";
  planId: string | undefined = undefined;
  baseValue: number = -1;
  price: number = 0;

  constructor(init?: Partial<CpPlansModel>) {
    Object.assign(this, init);
  }
}
